<template>
  <a-row class="content-fix" type="flex">
    <a-col class="height100 flex-1">
      <a-tabs class="main-tabs" type="card">
        <a-tab-pane key="content" class="main-tabs" type="card">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row align="middle" class="form_title sm-mb">
            <a-col :span="4" class="form_title"> Язык: </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>

          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Название: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['title_' + getKey]"
                name="linkName"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> ID dataegov: </a-col>
            <a-col :span="8" class="sm-mb">
              <a-input
                v-model="form.id_data_egov"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row class="sm-mb">
            <a-col :span="4" class="form_title"> Дата публикации: </a-col>
            <a-col :span="12">
              <input v-model="form.date" type="date" />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Ссылка на XML: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['file_url_xml_' + getKey]"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Ссылка на CSV: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['file_url_csv_' + getKey]"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Ссылка на JSON: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['file_url_json_' + getKey]"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Ссылка на XLS: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['file_url_xls_' + getKey]"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <a-row align="middle" class="flex-baseline">
            <a-col :span="4" class="form_title"> Ссылка на PDF: </a-col>
            <a-col :span="15" class="sm-mb">
              <a-input
                v-model="form['file_url_pdf_' + getKey]"
                class="form_title-input"
                placeholder="Введите название"
              />
            </a-col>
          </a-row>
          <!-- position -->
          <a-row align="middle" class="flex-baseline input-form__group">
            <a-col :span="4" class="form_title">
              {{ $t("MenuPosition") }}:
            </a-col>
            <a-col :span="12">
              <a-input-number
                v-model="form.position"
                placeholder="Введите позицию"
              />
              <div v-if="!form.position" class="error-text">
                Введите позицию
              </div>
            </a-col>
          </a-row>
          <!-- active toggle -->
          <a-row style="margin-bottom: 25px">
            <a-col :span="4" class="form_title"> Статус: </a-col>
            <a-switch v-model="form.is_active" />
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :span="4" />
            <a-col :span="12">
              <a-row>
                <a-button style="margin-right: 10px" @click="$router.go(-1)">
                  <a-icon type="close" />Отмена
                </a-button>
                <a-button
                  style="margin-left: 10px"
                  type="primary"
                  @click="
                    submit(form.id ? (saveback = false) : (saveback = true))
                  "
                >
                  <a-icon type="check" />
                  {{ form.id ? $t("Save") : $t("Add") }}
                </a-button>
                <a-button
                  v-if="form.id"
                  style="margin-left: 10px"
                  type="primary"
                  @click="submit((saveback = true))"
                >
                  <a-icon type="check" />
                  {{ $t("SaveAndExit") }}
                </a-button>
              </a-row>
            </a-col>
          </a-row>
        </a-tab-pane>
        <!-- <a-tab-pane key="documents">
          <span slot="tab"> <a-icon type="project" />Документы </span>
        </a-tab-pane> -->
      </a-tabs>
    </a-col>
  </a-row>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title_uz: "",
        title_ru: "",
        title_en: "",
        title_oz: "",
        title_qr: "",
        position: 1,
        id_data_egov: null,
        date: null,
        // xml
        file_url_xml_uz: "",
        file_url_xml_ru: "",
        file_url_xml_oz: "",
        file_url_xml_en: "",
        file_url_xml_qr: "",
        // csv
        file_url_csv_uz: "",
        file_url_csv_ru: "",
        file_url_csv_oz: "",
        file_url_csv_en: "",
        file_url_csv_qr: "",
        // json
        file_url_json_uz: "",
        file_url_json_ru: "",
        file_url_json_oz: "",
        file_url_json_en: "",
        file_url_json_qr: "",
        // xls
        file_url_xls_uz: "",
        file_url_xls_ru: "",
        file_url_xls_oz: "",
        file_url_xls_en: "",
        file_url_xls_qr: "",
        // pdf
        file_url_pdf_uz: "",
        file_url_pdf_ru: "",
        file_url_pdf_oz: "",
        file_url_pdf_en: "",
        file_url_pdf_qr: ""
      },
      langTab: "oz"
    }
  },
  computed: {
    getKey() {
      return this.langTab
    }
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      if (!this.$route.params.id) return
      let id = this.$route.params.id
      const { data } = await this.$api.get(`/admin/data-egov/${id}/detail/`)
      this.form = data
    },
    async submit(saveback) {
      let f = new FormData()
      Object.keys(this.form).forEach((key) => {
        this.form[key] && f.append(key, this.form[key])
      })
      const createOrUpdate = {
        url:
          this.form && this.form.id
            ? "/admin/data-egov/" + this.form.id + "/update/"
            : "/admin/data-egov/create/",
        method: this.form && this.form.id ? "patch" : "post"
      }
      try {
        let res = await this.$api[createOrUpdate.method](createOrUpdate.url, f)
        if ((res && res.status === 201) || res.status === 200) {
          this.$message.success(
            `Успешно ${this.form.id ? "обновлена" : "создана"}!`
          )
        }
        if (saveback) {
          await this.$router.push({ name: "dataegov" })
        }
      } catch (e) {
        this.$message.error(
          `Ошибка при ${this.form.id ? "обновлении" : "создании"}!`
        )
        console.error(e)
      }
    }
  }
}
</script>

<style>
.committee-image {
  overflow: hidden;
  margin-top: 15px;
}
.committee-image > img {
  height: 200px;
}
.isInvalidUrl {
  border: 1px solid red;
  box-shadow: 0 0 3px red;
}
.error-message {
  color: red;
  font-size: 12px;
}
</style>
